import React, { useState } from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions/inPersonTraining/eventOverview/associatedContent';
import EmptyStateAction from 'components/shared/EmptyStateAction';

import Modal from 'components/shared/modal';
import { TYPES, TYPE_ICONS } from 'constants/config';
import Picker from 'components/PathBuilder/Picker';

const AddNewContent = ({
  currentSessionId,
  addAssociatedContentItem,
  getAssociatedContent,
}) => {
  const [showAddContentModal, setShowAddContentModal] = useState(false);
  const [newContentType, setNewContentType] = useState(TYPES.PATH);

  const availableContentTypes = [
    {
      icon: TYPE_ICONS.Path,
      value: TYPES.PATH,
      title: t('paths.path_builder.blank_views.path.title'),
      description: t('in_person_training.event_content.assign_path'),
    },
    {
      icon: TYPE_ICONS.Lesson,
      value: TYPES.LESSON,
      title: t('paths.path_builder.blank_views.lesson.title'),
      description: t('in_person_training.event_content.assign_lesson'),
    },
    {
      icon: TYPE_ICONS.Certification,
      value: TYPES.CERTIFICATION,
      title: t('paths.path_builder.blank_views.certification.title'),
      description: t('in_person_training.event_content.assign_certification'),
    },
  ];

  const selectContentType = type => {
    setNewContentType(type);
    setShowAddContentModal(true);
  };

  const pickerTitle = type => {
    switch (type) {
      case TYPES.CERTIFICATION:
        return t('in_person_training.event_content.picker_title.certification');
      case TYPES.PATH:
        return t('in_person_training.event_content.picker_title.path');
      case TYPES.LESSON:
      default:
        return t('in_person_training.event_content.picker_title.lesson');
    }
  };

  const onContentPickerChange = content => {
    setShowAddContentModal(false);
    addAssociatedContentItem(content, currentSessionId);
  };

  return (
    <>
      <div className="d-f gap-16">
        {availableContentTypes.map(availableContentType => (
          <EmptyStateAction
            {...availableContentType}
            onClick={() => selectContentType(availableContentType.value)}
            key={availableContentType.title}
            pendoClassName="trk_button_learning_add-follow-up-content"
          />
        ))}
      </div>
      <Modal
        show={showAddContentModal}
        dismissCallback={() => setShowAddContentModal(!showAddContentModal)}
      >
        <Picker
          type={newContentType}
          title={pickerTitle(newContentType)}
          onChange={onContentPickerChange}
          onCancel={() => setShowAddContentModal(!showAddContentModal)}
          storeLocation={{
            storePath: 'associatedContent',
            contentArray: 'contentItems',
          }}
        />
      </Modal>
    </>
  );
};

const mapDispatchToProps = {
  addAssociatedContentItem: actions.addAssociatedContentItem,
  getAssociatedContent: actions.getAssociatedContent,
};

export default connect(null, mapDispatchToProps)(AddNewContent);
